<template>
  <header class="fixed top-1 sm:top-6 z-50 w-full" data-scroll-name="header">
    <Container>
      <div class="flex items-center justify-between shadow-sm bg-white px-6">
        <div 
          class="hidden sm:block truncate w-[190px] text-white py-2 px-4"
          :class="{
            'bg-primary-color': !getPrimaryColor,
            [`bg-[${getPrimaryColor}]`]: getPrimaryColor
          }"
        >
          {{ getAddress.address }}
        </div>
        
        <div :class="{
          'w-[calc(100%-50px)] sm:w-[calc(100%-272px)]': getMusic,
          'w-full sm:w-[calc(100%-222px)]': !getMusic,
          '-ml-4 sm:ml-0 sm:pl-4': true
        }">
          <nav
            :class="{
              'relative w-full': true,
              'before:absolute before:left-0 before:top-0 before:h-full before:w-6 before:bg-gradient-to-l before:from-transparent before:via-white/50 before:to-white before:content-[\'\']': true,
              'after:absolute after:right-0 after:top-0 after:h-full after:w-6 after:bg-gradient-to-r after:from-transparent after:via-white/50 after:to-white after:content-[\'\']': true
            }"
          >
            <ul class="scrollbar-hidden flex flex-row items-center gap-8 overflow-x-auto scroll-smooth py-6! pl-6! pr-6!">
              <li v-for="page in getPages" :key="page.value">
                <a
                  v-scroll="{name: page.value, offsetTop: 100}"
                  class="whitespace-nowrap font-light uppercase text-secondary! cursor-pointer"
                  :class="{
                    'hover:text-[var(--text-primary-color)]!': !getPrimaryColor,
                    [`hover:text-[${getPrimaryColor}]!`]: getPrimaryColor
                  }"
                  @click="clickLink(page)"
                >
                  {{ page.label }}
                </a>
              </li>
            </ul>
          </nav>
        </div>
      
        <div class="flex w-[50px] items-center justify-end" v-if="getMusic">
          <HMTAudio />
        </div>
      </div>
    </Container>
  </header>
</template>

<script>
  import { mapGetters } from 'vuex';

  import HMTAudio from '@/shared/components/Audio';
  import detectMobileMixin from '@/mixins/detectMobile';
  import gaMixin from '@/shared/mixins/ga';
  import Container from '../Container';

  export default {
    name: 'Header',
    mixins: [
      detectMobileMixin,
      gaMixin
    ],
    components: {
      HMTAudio,
      Container,
    },
    computed: {
      ...mapGetters('tour', ['getPages', 'getMusic', 'getAddress', 'getPrimaryColor']),
    },
    methods: {
      clickLink ({ value, label }) {
        this.isOpen = false;
        this.$emit('onClickLink', value);
        this.sendEventGA('Page', label);
      }
    },
  };
</script>
